module.exports = __webpack_public_path__ + "media/images/athletes/1504-6473efa9ffc1ccc6c81a2eb0c27c0d6f.png";